import React, { useContext, useEffect } from "react";
import qs from "qs";
import { downloadEmployeesSelected } from "usecases/employees/download-employees-selected-csv";
import { showErrorMessage } from "usecases/commons/show-error-message";
import { addContextLog, logError } from "infrastructure/log";
import { findCompanyId } from "infrastructure/repository/company-repository";
import {
  getEmployees,
  getEmployeesV2,
} from "infrastructure/repository/employees-repository";
import { sendEmployeeBulkSession } from "usecases/employees/send-employees-bulk-session";
import WrappedSidebarV2 from "v2/ui/components/SidebarV2";
import CompanyContext from "infrastructure/Contexts/components/data/CompanyWrapper/context";
import { CountryIsoCode } from "v2/domain/common/enums/CountryISOCode";
import { translate as t } from "../../../../infrastructure/translate/localization";
import EditEmployeesCsvPage from "./EditEmployeesCsvPage";

const EditEmployeesCsvPageWrapper = () => {
  const { company } = useContext(CompanyContext);
  const isMexicanCompany = company?.countryISO2Code === CountryIsoCode.MEXICO;

  useEffect(() => {
    const fetchFn = async () => {
      try {
        const { employees: employeesInQuery, ...query } = qs.parse(
          window.location.search.replace("?", "")
        );

        const resultantEmployees = Array.isArray(employeesInQuery)
          ? employeesInQuery
          : [employeesInQuery];

        const companyId = await findCompanyId();

        let data = [];

        if (employeesInQuery === "all") {
          const {
            data: {
              metainfo: {
                pagination: { totalItems },
              },
            },
          } = await getEmployeesV2({
            companyId,
            query: qs.stringify(query),
          });

          const res = await getEmployeesV2({
            companyId,
            query: qs.stringify({
              ...query,
              pageSize: Number(totalItems),
            }),
          });
          data = res.data.content;
        } else {
          const res = await getEmployees({
            companyId,
            params: undefined,
          });
          data = res.data;
        }

        await sendEmployeeBulkSession(
          employeesInQuery === "all"
            ? data.map(({ id }) => id)
            : resultantEmployees
        );

        await downloadEmployeesSelected(
          employeesInQuery === "all"
            ? data
            : data.filter(({ id }) =>
                resultantEmployees?.some((qId) => id === qId)
              ),
          isMexicanCompany
        );
        addContextLog("info", "EditEmployeesCsvPage", "display-screen");
      } catch (e) {
        logError(e, "Error to display EditEmployeesCsvPage");
        showErrorMessage(
          t("edit-employees.edit-employees-upload-error"),
          true,
          e
        );
      }
    };

    fetchFn();
  }, [isMexicanCompany]);

  return (
    <>
      <WrappedSidebarV2 />
      <div id="page-container">
        <EditEmployeesCsvPage />
      </div>
    </>
  );
};

export default EditEmployeesCsvPageWrapper;
